var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"article"},[(_setup.isLegacy)?_c(_setup.LegacyArticle):(_setup.isLegacy === false)?_c(_setup.EditorialArticle):_vm._e(),(_setup.isLegacy !== null)?_c(_setup.AppFooter):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }